import React from "react";
import { GiChefToque } from "react-icons/gi";
import sutherlandLogo from '../assets/img/sutherlandglobal.png';
import esealLogo from '../assets/img/big-logo.png';
import luminaBanner from '../assets/img/lumina-2026-banner.png';
import vegIcon from '../assets/img/veg.png';
import nonVegIcon from '../assets/img/non-veg.png';
import { VegRecipeUI } from "./VegRecipeUI";
import { NonVegRecipeUI } from "./NonVegRecipeUI";

/**
 * Combined, responsive Lumina 2026 recipe page.
 *
 * Reuses the existing VegRecipeUI / NonVegRecipeUI components as-is
 * (same recipe data, markup, per-recipe PDF logic still exists on their
 * own routes) and wraps them with the branded header/footer + a single
 * combined "Download Lumina Recipes (PDF)" button, styled per the
 * Lumina 2026 visual reference.
 */
export function LuminaRecipesPage() {
  return (
    <div className="lumina-recipes-page">
      <div>
        <header className="lumina-recipes-page__header">
          <div className="lumina-recipes-page__header-left">
            <GiChefToque className="lumina-recipes-page__header-icon" />
            <span>Good Food<br />Brighter Ideas!</span>
          </div>
          <div className="lumina-recipes-page__header-center">
            <img src={luminaBanner} alt="Lumina 2026 - Des Annual Day" />
          </div>
          <div className="lumina-recipes-page__header-right">
            <span className="lumina-recipes-page__header-right-title">Eng<strong>AI</strong>neering</span>
            <span className="lumina-recipes-page__header-right-sub">OUTCOMES</span>
          </div>
        </header>

        <div className="lumina-recipes-page__grid">
          <div className="lumina-recipes-page__card lumina-recipes-page__card--veg">
            <div className="lumina-recipes-page__card-top">
              <div className="lumina-recipes-page__card-top-left">
                {/* <span className="lumina-recipes-page__badge">
                  <img src={vegIcon} alt="" className="lumina-recipes-page__badge-icon" />
                  VEG RECIPE
                </span> */}
                <h2 className="lumina-recipes-page__card-top-title">PANEER - E – LUMINA Recipe</h2>
              </div>
              <img src={vegIcon} alt="PANEER - E – LUMINA Recipe" className="lumina-recipes-page__dish-image" />
            </div>
            <VegRecipeUI />
          </div>

          <div className="lumina-recipes-page__card lumina-recipes-page__card--nonveg">
            <div className="lumina-recipes-page__card-top">
              <div className="lumina-recipes-page__card-top-left">
                {/* <span className="lumina-recipes-page__badge">
                  <img src={nonVegIcon} alt="" className="lumina-recipes-page__badge-icon" />
                  NON-VEG RECIPE
                </span> */}
                <h2 className="lumina-recipes-page__card-top-title">LUMINA ALMOND KISSED CHICKEN Recipe</h2>
              </div>
              <img src={nonVegIcon} alt="LUMINA ALMOND KISSED CHICKEN Recipe" className="lumina-recipes-page__dish-image" />
            </div>
            <NonVegRecipeUI />
          </div>
        </div>
      </div>

      <div className="lumina-recipes-page__download">
        <a href="/lumina/Lumina-2026-Special-Recipes.zip" download="Lumina-2026-Special-Recipes.zip">
          <button type="button" className="lumina-recipes-page__download-btn">
            Download Lumina Recipes (PDF)
          </button>
        </a>
      </div>

      <footer className="lumina-recipes-page__footer">
        <img src={sutherlandLogo} alt="Sutherland Logo" className="lumina-recipes-page__footer-logo" />
        <span className="lumina-recipes-page__footer-divider" />
        <div className="lumina-recipes-page__powered">
          Developed by <img src={esealLogo} alt="eSeal Logo" className="lumina-recipes-page__powered-logo" /> eSeal Team
        </div>
      </footer>
    </div>
  );
}
